const CARDS = [
  {
    title: '鬼灭之刃 无限城篇',
    tag: '热血 · 连载中',
    desc: '炭治郎与鬼杀队攻入无限城，与无惨的最终决战一触即发。下拉式阅读带来行云流水的战斗画面体验。',
    img: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20illustration%20of%20a%20young%20warrior%20with%20a%20katana%20in%20a%20dynamic%20battle%20pose%2C%20warm%20orange%20and%20red%20energy%20effects%2C%20clean%20simple%20background%20with%20soft%20gradient%2C%20Japanese%20anime%20art%20style%2C%20vibrant%20warm%20colors%2C%20detailed%20character%20design%2C%20dramatic%20lighting&width=800&height=1120&seq=card-manga-01&orientation=portrait',
  },
  {
    title: '咒术回战',
    tag: '热血 · 连载中',
    desc: '五条悟的过去终于揭晓，咒术世界的宏大篇章逐步展开。翻页漫画模式带来最经典的阅读节奏。',
    img: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20illustration%20of%20a%20powerful%20sorcerer%20character%20with%20floating%20cursed%20energy%20surrounding%20them%2C%20warm%20amber%20and%20dark%20orange%20color%20palette%2C%20minimalist%20background%20with%20soft%20illumination%2C%20Japanese%20anime%20art%20style%2C%20detailed%20character%20illustration%2C%20dramatic%20composition&width=800&height=1120&seq=card-manga-02&orientation=portrait',
  },
  {
    title: '海贼王 最终章',
    tag: '冒险 · 连载中',
    desc: '路飞与伙伴们向着最终之岛进发，二十余年的传奇即将迎来高潮。全屏观看体验最宏大的冒险。',
    img: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20illustration%20of%20a%20pirate%20character%20with%20a%20straw%20hat%20standing%20on%20a%20ship%20deck%20facing%20the%20ocean%20sunset%2C%20warm%20golden%20hour%20lighting%2C%20adventure%20atmosphere%2C%20Japanese%20anime%20art%20style%2C%20vibrant%20warm%20colors%2C%20scenic%20composition&width=800&height=1120&seq=card-manga-03&orientation=portrait',
  },
  {
    title: '间谍过家家',
    tag: '喜剧 · 连载中',
    desc: '福杰一家的温馨日常与刺激任务交织，阿尼亚的读心能力引发无数笑料。无弹窗模式享受纯净喜剧。',
    img: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20illustration%20of%20a%20cute%20family%20of%20three%20including%20a%20little%20girl%20with%20pink%20hair%20smiling%20brightly%2C%20warm%20cozy%20home%20atmosphere%2C%20soft%20peach%20and%20cream%20color%20palette%2C%20Japanese%20anime%20art%20style%2C%20heartwarming%20scene%2C%20clean%20composition&width=800&height=1120&seq=card-manga-04&orientation=portrait',
  },
  {
    title: '坂本日常',
    tag: '动作 · 连载中',
    desc: '传说中的最强杀手坂本太郎，退休后经营便利店却遭遇各路杀手挑战，搞笑又热血的日常。',
    img: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20illustration%20of%20a%20cool%20middle-aged%20man%20in%20a%20convenience%20store%20uniform%20with%20a%20confident%20smile%2C%20subtle%20action%20pose%2C%20warm%20interior%20lighting%2C%20Japanese%20anime%20art%20style%2C%20clean%20simple%20background%2C%20warm%20amber%20tones&width=800&height=1120&seq=card-manga-05&orientation=portrait',
  },
  {
    title: '蓝色监狱',
    tag: '运动 · 连载中',
    desc: '300名高中前锋被关进蓝色监狱，残酷的淘汰赛中诞生世界第一前锋。下拉式阅读畅享紧张赛事节奏。',
    img: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20illustration%20of%20a%20soccer%20player%20in%20dynamic%20action%20running%20with%20a%20ball%20on%20a%20field%2C%20intense%20sports%20atmosphere%2C%20warm%20orange%20and%20blue-tinted%20gradient%20lighting%2C%20Japanese%20anime%20art%20style%2C%20dramatic%20composition%2C%20energy%20effects&width=800&height=1120&seq=card-manga-06&orientation=portrait',
  },
  {
    title: '怪兽8号',
    tag: '科幻 · 连载中',
    desc: '32岁清洁工日比野卡夫卡意外获得变身怪兽的能力，为了实现儿时梦想加入防卫队。热血逆袭之作。',
    img: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20illustration%20of%20a%20determined%20man%20with%20monster-like%20partial%20transformation%20features%2C%20sci-fi%20atmosphere%2C%20warm%20orange%20and%20dark%20gray%20color%20palette%2C%20Japanese%20anime%20art%20style%2C%20dramatic%20lighting%2C%20clean%20composition&width=800&height=1120&seq=card-manga-07&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center">
            <i className="ri-book-open-line text-accent-600 text-xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">本周推荐</h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {CARDS.map((card, i) => (
            <article
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[5/7] overflow-hidden bg-background-100">
                <img
                  src={card.img}
                  alt={card.title}
                  title={`${card.title} - 爱漫画网`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] md:text-xs font-semibold text-background-50 bg-accent-500/90 px-2 py-1 rounded-md whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900 mb-1.5 line-clamp-1">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}